import { HeadCell } from '../../../models/Table';

export interface IAliasTable {
  id: number;
  alias: string;
  user: string;
  site: string;
  status: string;
}

export const columnsAlias: HeadCell[] = [
  {
    id: 'smtp-alias',
    disablePadding: false,
    disableSort: false,
    main: true,
    label: 'Alias',
  },
  {
    id: 'user__username',
    disablePadding: false,
    disableSort: false,
    label: 'User',
  },
  {
    id: 'site__name',
    disablePadding: false,
    disableSort: false,
    label: 'Site',
  },
  {
    id: 'is_active',
    disablePadding: false,
    disableSort: false,
    label: 'Active',
  },
];

export interface AliasFormInterface {
  smtp_alias: string;
  user_id: number;
  site_id: number | null;
  is_active: boolean;
}

export const AliasFormObjectDefault: AliasFormInterface = {
  smtp_alias: '',
  user_id: 0,
  site_id: 0,
  is_active: true,
};
